import axios from "shared/api/axiosConfig";
import { encryptApiBodyFromJSON } from "shared/api/cryptApiBody";


export async function createTrustfull(phone_number, email, first_name, last_name, place_of_birth, date_of_birth, type) {
    const response = await axios.post("/client/trustfull/enrich", {
        encrypt: encryptApiBodyFromJSON({ phone_number, email, first_name, last_name, place_of_birth, date_of_birth }),
        type
    });
    return response;
}